import React, { useState } from "react";
import { Eye, Edit, Trash2 } from "lucide-react";
import ConfirmDeleteModal from "./ConfirmDeleteModal";

/**
 * Professional activity action buttons
 */
const ActivityActions = ({
  activity,
  canEdit,
  canDelete = canEdit,
  onViewDetails,
  onEdit,
  onDelete,
}) => {
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const handleDelete = () => {
    onDelete();
    setShowDeleteConfirm(false);
  };

  return (
    <>
      <div className="flex items-center gap-2 flex-shrink-0">
        {/* View Details */}
        <button
          onClick={onViewDetails}
          className="
            inline-flex items-center gap-1.5 px-3 py-2
            text-sm font-medium text-blue-700
            bg-blue-50 hover:bg-blue-100
            rounded-lg transition-colors duration-200
            focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
          "
        >
          <Eye className="w-4 h-4" />
          <span className="hidden sm:inline">View</span>
        </button>

        {/* Edit */}
        <button
          onClick={onEdit}
          disabled={!canEdit}
          className={`
            inline-flex items-center gap-1.5 px-3 py-2
            text-sm font-medium rounded-lg transition-colors duration-200
            focus:outline-none focus:ring-2 focus:ring-offset-2
            ${
              canEdit
                ? "text-gray-700 bg-gray-100 hover:bg-gray-200 focus:ring-gray-400 cursor-pointer"
                : "text-gray-400 bg-gray-50 cursor-not-allowed"
            }
          `}
          title={!canEdit ? "Approved activities cannot be edited" : "Edit activity"}
        >
          <Edit className="w-4 h-4" />
          <span className="hidden sm:inline">Edit</span>
        </button>

        {/* Delete */}
        <button
          onClick={() => setShowDeleteConfirm(true)}
          disabled={!canDelete}
          className={`
            inline-flex items-center gap-1.5 px-3 py-2
            text-sm font-medium rounded-lg transition-colors duration-200
            focus:outline-none focus:ring-2 focus:ring-offset-2
            ${
              canDelete
                ? "text-red-700 bg-red-50 hover:bg-red-100 focus:ring-red-500 cursor-pointer"
                : "text-gray-400 bg-gray-50 cursor-not-allowed"
            }
          `}
          title={
            !canDelete ? "Approved activities cannot be deleted" : "Delete activity"
          }
        >
          <Trash2 className="w-4 h-4" />
          <span className="hidden sm:inline">Delete</span>
        </button>
      </div>

      {/* Delete Confirmation Modal */}
      <ConfirmDeleteModal
        isOpen={showDeleteConfirm}
        onClose={() => setShowDeleteConfirm(false)}
        onConfirm={handleDelete}
        activityTitle={activity.title}
      />
    </>
  );
};

export default ActivityActions;


